import { useLocSettings } from "../../hooks/SettingsHooks";
import PropTypes from "prop-types";
import {
  useSpecsTranslation,
  useUnitTranslation
} from "../../hooks/TranslationHooks";
import COLORS from "../../config/colors";

const LabelIcon = ({ field, value, unit }) => {
  const settings = useLocSettings();
  const ts = useSpecsTranslation();
  const tu = useUnitTranslation();

  const icon = settings.specifications?.[field]?.icons?.[value];

  if (icon) {
    return (
      <span className={"spec-wrapper"}>
        <span
          className={"spec-icon"}
          style={{
            color: icon.color || COLORS.bjelin_grey
          }}
          dangerouslySetInnerHTML={{ __html: icon.svg2 || icon.svg }}
        />
        <div className={"spec-icon-label"}>
          <div>{ts(field)}</div>
          <div style={{ fontWeight: 500 }}>
            {ts(field, value)} {unit && tu(unit)}
          </div>
        </div>
      </span>
    );
  }
  return null;
};

LabelIcon.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

const LabelIcons = ({ specsIndexed = {}, showLabel = false, sku }) => {
  const settings = useLocSettings();

  const icons = Object.entries(specsIndexed)
    .map(([field, { value, unit }]) => {
      const icon = settings.specifications?.[field]?.icons?.[value];
      return icon ? { field, value, unit, showLabel, sku } : null;
    })
    .filter(icon => icon !== null);

  return icons.length
    ? icons.map(({ field, value, unit, sku }) => {
        return (
          <LabelIcon
            field={field}
            value={value}
            unit={unit}
            showLabel
            key={field + "_" + value}
            sku={sku}
          />
        );
      })
    : "";
};

LabelIcons.propTypes = {
  specsIndexed: PropTypes.object.isRequired
};

export default LabelIcons;
